"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.algoliaServer = void 0;
const algoliasearch_1 = require("algoliasearch");
const algoliaServer = (appId, apiKey) => {
    const algoliaInstance = (0, algoliasearch_1.algoliasearch)(appId, apiKey);
    return {
        /**
         * To Search from a single.
         * @param {String} params.indexName - Algolia target index
         * @param {Object} params.searchParams - Search params like filter, query etc.
         * @param {Object} reqOption - Optional reqOptions like header etc.
         * @returns {Promise<Object>} Multi-index search results.
         */
        search: async (params, reqOption) => {
            return algoliaInstance.searchSingleIndex(params, reqOption);
        },
        /**
         * To Search from a single.
         * @param {String} params.indexName - Algolia target index
         * @param {Object} params.browseParams - browse params like filter, query etc.
         * @param {Object} reqOption - Optional reqOptions like header etc.
         * @returns {Promise<Object>} Multi-index search results.
         */
        browse: async (params, reqOption) => {
            return algoliaInstance.browse(params, reqOption);
        },
        /**
         * To Search from a multi-indexes.
         * @param {Array<Object>} searchParams - Search parameters for each index.
         * @param {string} strategy - Strategy for search execution.
         * @returns {Promise<Object>} Multi-index search results.
         */
        multiIndexSearch: async (searchParams, strategy, reqOption) => {
            return algoliaInstance.search({ requests: searchParams, strategy }, reqOption);
        },
    };
};
exports.algoliaServer = algoliaServer;
